import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';

import { HubConfigRolesSettingsService } from '@main-client/src/app/hub-configuration/hub-config-roles/hub-config-roles-settings/hub-config-roles-settings.service';

import { HubConfigRolesSettingsComponent } from './hub-config-roles-settings.component';

@NgModule({
  declarations: [HubConfigRolesSettingsComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    NzDrawerModule,
    ReactiveFormsModule,
    ToastModule,
    TtcButtonSharedModule,
  ],
  providers: [HubConfigRolesSettingsService],
})
export class HubConfigRolesSettingsModule {}
